/* eslint-disable no-unused-vars */
import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _ from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useFormState } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllAsync, selectMoedas } from '../../features/moeda/moedaSlice';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';

export default function QCXSelectMoedaAutocomplete({ label, name, initialValues, defaultCode, ...restProps }) {
  const dispatch = useDispatch();
  const list = useSelector(selectMoedas);
  useEffect(() => {
    if (list.length === 0) {
      dispatch(fetchAllAsync());
    }
  }, [dispatch, list]);

  const { values } = useFormState();
  const localInitialValues = useMemo(() => initialValues || values, [initialValues, values]);

  const [defaultValue, setDefaultValue] = useState('');
  useEffect(() => {
    const defaultMoeda = list?.find((m) => m.code === defaultCode);
    if (defaultMoeda) {
      setDefaultValue(defaultMoeda);
      return;
    }

    const value = list.find((item) => {
      const formValue = _.get(localInitialValues, name);

      return item?.id === Number(formValue) || item?.id === formValue?.id;
    });
    if (value) {
      setDefaultValue(value);
    } else {
      setDefaultValue({ id: null, description: '' });
    }
  }, [list, localInitialValues, name, defaultCode]);

  const getOptionLabel = useCallback((item) => {
    if (!item.code || !item.description) return '';

    return `${item?.description} - ${item?.code?.padStart(3, '0')}`;
  }, []);

  const filterOptions = createFilterOptions({
    stringify: (option) => `${option.code} - ${option.description}`,
  });
  return (
    <QCXAutocompleteSelect
      label={label}
      id={name}
      name={name}
      options={list}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={getOptionLabel}
      {...restProps}
    />
  );
}
